<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" persistent>
      <!-- SK스페셜티 보안 서약서 -->
      <v-card class="pa-4">
        <v-card class="mt-n4 hidden-sm-and-down" flat>
          <v-card-title class="pledge_title">
            <div class="red--text text--darken-2">회원가입 동의서</div>
            <v-spacer></v-spacer>
            <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
          </v-card-title>
          <v-divider></v-divider>

          <div style="overflow:auto;height:calc(90vh - 200px);">
            <div id="TopScrollId" style="height:10px;"></div>
            <div class="ma-8 mt-2">
              <div class="d-flex align-center mb-n4">
                <div class="font-weight-bold text-h6 grey--text text--darken-3">보안 서약서 동의(필수)</div>
                <v-spacer></v-spacer>
                <v-checkbox v-model="CheckAll" @change="bCheckAll('bAllCheck1Ref')" color="black">
                  <template v-slot:label>
                    <div class="black--text">
                      전체 동의합니다.
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>
              <v-card class="pa-4 mt-8 text-subtitle-1 grey--text text--darken-3 lineHeight2" outlined height="200px" style="overflow-y:auto;">
                {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 "회사"라 함)를 출입하는 데서 다음의 정보보호에 관한 내용에 동의하며, 상호신뢰 하에 성실히 준수할 것을 서약합니다
                <div class="lineHeight2 mt-8 text-subtitle-1 grey--text text--darken-3">
                  <div v-for="item in oSecPeldge" :key="item.cId" class="d-flex">
                    <div>{{item.cId}}&nbsp;</div>
                    <div>{{item.cComment}}</div>
                  </div>
                </div>
              </v-card>

              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-checkbox v-model="checkbox1" @change="bCheckPart()" color="black">
                  <template v-slot:label>
                    <div class="black--text">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>


            <div class="ma-8">
              <div class="font-weight-bold text-h6 grey--text text--darken-3">개인정보 수집 및 이용 동의(필수)</div>
              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>

              <v-card class="pa-4 mt-8 text-subtitle-1 grey--text text--darken-3 lineHeight2" outlined height="200px" style="overflow-y:auto;">
                {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 '회사'라고 함)는 개인정보와 관련된 정보통신망 이용 촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법') 및 개인정보보호에 관한 법률(이하 '개인정보 보호법') 등을 준수합니다. 개인정보 처리에 대한 상세한 사항은 개인정보 처리 방침을 참고하여 주시기를 바랍니다.

                <div class="lineHeight2 mt-8 text-subtitle-1 grey--text text--darken-3">
                  <div class="d-flex mb-1">
                    <div>1.&nbsp;</div>
                    <div>개인정보의 수집 및 이용</div>
                  </div>

                  <table class="type09 text-center text-subtitle-1 grey--text text--darken-3">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 목적</td>
                        <td>수집 항목</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>
                          1) 홈페이지 회원가입, 운영 및 유지보수<br>
                          2) 공장 출입 통제 및 관리 운영
                        </td>
                        <td>성명, 비밀번호, 연락처, 회사명, 사업자등록번호, 회사 주소, 직급, 사진</td>
                        <td>회원 탈퇴 후 1년간 별도 보관 후 삭제, 또는 정보 주체의 개인정보 삭제 요청 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-subtitle-1 pl-4 mt-4 mb-4">
                    -이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 정보 주체로부터 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 다만, 정보 주체로부터 동의받은 개인정보 보유 기간이 경과하거나, 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관 장소를 달리하여 보존합니다.
                  </div>

                  <div class="d-flex mb-1">
                    <div>2.&nbsp;</div>
                    <div>개인 영상정보의 수집 및 이용</div>
                  </div>
                  <div class="pl-4">
                    회사는 개인정보 보호법 제25조 1항에 따라 다음과 같은 목적으로 영상정보처리기기를 설치하여 개인 영상정보를 수집 및 관리하고 있습니다.
                  </div>
                  <div class="mt-4 mb-4 pl-4">
                    <div class="d-flex">
                      <div>1)&nbsp;</div>
                      <div>이용목적</div>
                    </div>
                    <div class="mb-2 pl-4">
                      -시설 안전 및 화재 예방<br>
                      -정보 주체의 안전을 위한 범죄 예방<br>
                      -외부인 불법침입 방지<br>
                      -차량 도난 및 파손 방지<br>
                      (※ 주차장의 경우 「주차장법 시행규칙」 제6조 제1항을 근거로 설치·운영)
                    </div>

                    <div class="d-flex">
                      <div>2)&nbsp;</div>
                      <div>보유 및 이용 기간</div>
                    </div>
                    <div class="mb-2 pl-4">
                      -촬영일로부터 1개월간 보관 후 삭제
                    </div>
                  </div>


                  <div class="d-flex mb-1">
                    <div>3.&nbsp;</div>
                    <div>개인정보의 위탁 및 제 3자 제공</div>
                  </div>
                  <div class="text-subtitle-1 pl-4">
                    회사는 서비스 이행을 위해 아래와 같이 개인정보를 위탁하고 있으며 제 3자 제공은 하지 않습니다. 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
                  </div>
                  <div class="mt-4 mb-4 pl-4">
                    <div class="d-flex">
                      <div>1)&nbsp;</div>
                      <div>출입 방문시스템 운영</div>
                    </div>
                    <div class="mb-2 pl-4">
                      위탁받는 자(수탁자) : M4<br>
                      위탁하는 업무의 내용<br>
                      - 홈페이지 운영 및 유지보수
                    </div>
                    
                    <div class="d-flex">
                      <div>2)&nbsp;</div>
                      <div>출입 통제 및 관리, 영상정보처리기기 운영</div>
                    </div>
                    <div class="mb-2 pl-4">
                      위탁받는 자(수탁자) : 캡스텍<br>
                      위탁하는 업무의 내용<br>
                      - 공장 출입을 위한 출입자 신원 확인 등의 출입 통제, 관리 운영<br>
                      - 화재, 범죄 예방을 위해 공장 주요 도선, 외곽에 설치한 영상정보처리기기 운영 및 비상 상황 대응 활동 등
                    </div>
                  </div>


                  <div class="d-flex mb-1">
                    <div>4.&nbsp;</div>
                    <div>동의 거부 권리 및 동의 거부 시 불이익 내용</div>
                  </div>
                  <div class="text-subtitle-1 pl-4">
                    귀하는 위와 같은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우에는 출입 방문시스템({{HomepageURL}}) 사이트의 회원가입을 할 수 없으며 출입증 발급 및 회사 출입이 불가능합니다.
                  </div>
                </div>
              </v-card>

              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-checkbox v-model="checkbox2" @change="bCheckPart()" color="black">
                  <template v-slot:label>
                    <div class="black--text">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>
            
            
            <div class="ma-8">
              <div class="font-weight-bold text-h6 grey--text text--darken-3">위치정보 수집·이용 동의(필수)</div>
              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>

              <v-card class="pa-4 mt-8 text-subtitle-1 grey--text text--darken-3 lineHeight2" outlined height="200px" style="overflow-y:auto;">
                당사를 출입하는 데 출입자 관리상 개인정보 제공이 필요하다는 것을 이해하고 있으며 이를 위해 '개인정보 보호법' 등의 관련 법률에 따라 당사가 아래의 개인정보를 수집·이용하는 것에 추가 동의합니다.<br>
                당사가 제공하고 있는 공장 내에서 패용하여야 하는 “Smart Tag”는 주기적으로 위치정보를 송신하는 장치이며, 당사는 “Smart Tag”를 통하여 공장 내에서 귀하의 개인 위치 정보를 수집합니다.<br>
                <div class="mt-4 red--text">[필수]<br>
                </div>
                <div class="lineHeight2 text-subtitle-1 grey--text text--darken-3 mb-2">
                  <table class="type09 text-center">
                    <thead>
                    <tr>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 항목</td>
                        <td>수집 방법</td>
                        <td>수집·이용목적</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>위치정보</td>
                        <td>Smart Tag (블루투스)</td>
                        <td>안전</td>
                        <td>수집일로부터 1년</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="mt-4 red--text">[선택]</div>
                  <table class="type09 text-center">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 항목</td>
                        <td>수집 방법</td>
                        <td>수집·이용목적</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>위치정보</td>
                        <td>Smart Tag (블루투스)</td>
                        <td>방문객의 출입 위규 분석</td>
                        <td>수집일로부터 1년, 다만 정보 주체의 출입 보안 관련 위규 사항이 적발되었을 때는 그로부터 사건 처리 종료 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card>

              <div class="d-flex">
                <v-spacer></v-spacer>
                <!-- id="check_order_3" -->
                <v-checkbox v-model="checkbox3" @change="bCheckPart()" color="black" id="check_order_3">
                  <template v-slot:label>
                    <div class="black--text">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>


            <v-card-text class="hidden-sm-and-up text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3 lineHeight3">
              본인은 상기 사항을 숙지하였으며, 성실히 준수할 것을 서약합니다. 만일 상기 사항을 위반할 경우 회사의 사규에 따른 어떠한 조치도 감수할 것이며, 관련법률에 따른 민·형사상 책임 및 회사에 발생한 모든 손해에 대한 배상 책임을 부담하겠습니다.
            </v-card-text>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 주식회사 귀중
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="pb-1">
              <v-spacer></v-spacer>
              <!-- <v-btn width="100" @click="CloseDialog()" dark>취소하기</v-btn> -->
              <v-btn width="100" @click="closePage()">취소</v-btn>
              <v-btn width="100" @click="NextPage()" dark id="bAllCheck1Ref">동의하기</v-btn>
            </v-card-actions>
          </div>          
        </v-card>

        <v-card class="mt-n4 d-md-none" flat>
          <v-card-title>
            <div class="text-h5 text-sm-h4 red--text text--darken-2">회원가입 동의서1</div>
            <v-spacer></v-spacer>
            <img class="hidden-xs-only" :src="$store.state.CustomInfo.SiteId +'.svg'" style="height:35px"/>
            <img class="hidden-sm-and-up" :src="$store.state.CustomInfo.SiteId +'.svg'" style="height:30px"/>
          </v-card-title>
          <v-divider></v-divider>

          <div style="overflow:auto;height:calc(90vh - 400px);">
            <div id="TopScrollId_1" style="height:10px;"></div>
            <div class="ma-4 mt-2">
              <div class="d-flex align-center mb-n4">
                <div class="mb-2 font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">보안 서약서 동의(필수)</div>
                <v-spacer></v-spacer>
                <v-checkbox v-model="CheckAll" @change="bCheckAll('bAllCheck2Ref')" color="black" dense>
                  <template v-slot:label>
                    <div class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">
                      전체 동의합니다.
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>
              <v-card class="pa-4 mt-6 text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3 lineHeight3" outlined height="200px" style="overflow-y:auto;">
                {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 "회사"라 함)를 출입하는 데서 다음의 정보보호에 관한 내용에 동의하며, 상호신뢰 하에 성실히 준수할 것을 서약합니다
                <div class="lineHeight3 mt-4 text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                  <div v-for="item in oSecPeldge" :key="item.cId" class="d-flex">
                    <div>{{item.cId}}&nbsp;</div>
                    <div>{{item.cComment}}</div>
                  </div>
                </div>
              </v-card>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-checkbox v-model="checkbox1" @change="bCheckPart()" color="black" dense ref="checkbox1Ref">
                  <template v-slot:label>
                    <div class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>


            <div class="ma-4">
              <div class="mb-2 font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">개인정보 수집 및 이용 동의(필수)</div>
              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>
              <v-card class="pa-4 mt-6 text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3 lineHeight3" outlined height="200px" style="overflow-y:auto;">
                {{$store.state.CustomInfo.SiteNm}} 주식회사(이하 '회사'라고 함)는 개인정보와 관련된 정보통신망 이용 촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법') 및 개인정보보호에 관한 법률(이하 '개인정보 보호법') 등을 준수합니다. 개인정보 처리에 대한 상세한 사항은 개인정보 처리 방침을 참고하여 주시기를 바랍니다.
                <div class="lineHeight3 mt-4 text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                  <div class="d-flex mb-1">
                    <div>1.&nbsp;</div>
                    <div>개인정보의 수집 및 이용</div>
                  </div>
                  <table class="type09 text-center text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 목적</td>
                        <td>수집 항목</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>
                          1) 홈페이지 회원가입, 운영 및 유지보수<br>
                          2) 공장 출입 통제 및 관리 운영
                        </td>
                        <td>성명, 비밀번호, 연락처, 회사명, 사업자등록번호, 회사 주소, 직급, 사진</td>
                        <td>회원 탈퇴 후 1년간 별도 보관 후 삭제, 또는 정보 주체의 개인정보 삭제 요청 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-caption text-sm-subtitle-1 font-weight-bold pl-4 mt-4 mb-4">
                    -이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 정보 주체로부터 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 다만, 정보 주체로부터 동의받은 개인정보 보유 기간이 경과하거나, 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관 장소를 달리하여 보존합니다.
                  </div>


                  <div class="d-flex mb-1">
                    <div>2.&nbsp;</div>
                    <div>개인 영상정보의 수집 및 이용</div>
                  </div>
                  <div class="pl-4">
                    회사는 개인정보 보호법 제25조 1항에 따라 다음과 같은 목적으로 영상정보처리기기를 설치하여 개인 영상정보를 수집 및 관리하고 있습니다.
                  </div>
                  <div class="mt-4 mb-4 pl-4">
                    <div class="d-flex">
                      <div>1)&nbsp;</div>
                      <div>이용목적</div>
                    </div>
                    <div class="mb-2 pl-4">
                      -시설 안전 및 화재 예방<br>
                      -정보 주체의 안전을 위한 범죄 예방<br>
                      -외부인 불법침입 방지<br>
                      -차량 도난 및 파손 방지<br>
                      (※ 주차장의 경우 「주차장법 시행규칙」 제6조 제1항을 근거로 설치·운영)
                    </div>
                    <div class="d-flex">
                      <div>2)&nbsp;</div>
                      <div>보유 및 이용 기간</div>
                    </div>
                    <div class="mb-4 pl-4">
                      -촬영일로부터 1개월간 보관 후 삭제
                    </div>
                  </div>


                  <div class="d-flex mb-1">
                    <div>3.&nbsp;</div>
                    <div>개인정보의 위탁 및 제 3자 제공</div>
                  </div>
                  <div class="pl-4">
                    회사는 서비스 이행을 위해 아래와 같이 개인정보를 위탁하고 있으며 제 3자 제공은 하지 않습니다. 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
                  </div>
                  <div class="mt-4 mb-4 pl-4">
                    <div class="d-flex">
                      <div>1)&nbsp;</div>
                      <div>출입 방문시스템 운영</div>
                    </div>
                    <div class="mb-2 pl-4">
                      위탁받는 자(수탁자) : M4<br>
                      위탁하는 업무의 내용<br>
                      - 홈페이지 운영 및 유지보수
                    </div>

                    <div class="d-flex">
                      <div>2)&nbsp;</div>
                      <div>출입 통제 및 관리, 영상정보처리기기 운영</div>
                    </div>
                    <div class="mb-2 pl-4">
                      위탁받는 자(수탁자) : 캡스텍<br>
                      위탁하는 업무의 내용<br>
                      - 공장 출입을 위한 출입자 신원 확인 등의 출입 통제, 관리 운영<br>
                      - 화재, 범죄 예방을 위해 공장 주요 도선, 외곽에 설치한 영상정보처리기기 운영 및 비상 상황 대응 활동 등
                    </div>
                  </div>

                  <div class="d-flex mb-1">
                    <div>4.&nbsp;</div>
                    <div>동의 거부 권리 및 동의 거부 시 불이익 내용</div>
                  </div>
                  <div class="pl-4">
                    귀하는 위와 같은 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부할 경우에는 출입 방문시스템({{HomepageURL}}) 사이트의 회원가입을 할 수 없으며 출입증 발급 및 회사 출입이 불가능합니다.
                  </div>
                </div>
              </v-card>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-checkbox v-model="checkbox2" @change="bCheckPart()" color="black" dense ref="checkbox2Ref">
                  <template v-slot:label>
                    <div class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>
            
            
            <div class="ma-4">
              <div class="mb-2 font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">위치정보 수집·이용 동의(필수)</div>
              <v-divider color="black" class="mt-2"></v-divider>
              <v-divider color="black" ></v-divider>
              <v-card class="pa-4 mt-6 text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3 lineHeight3" outlined height="200px" style="overflow-y:auto;">
                당사를 출입하는 데 출입자 관리상 개인정보 제공이 필요하다는 것을 이해하고 있으며 이를 위해 '개인정보 보호법' 등의 관련 법률에 따라 당사가 아래의 개인정보를 수집·이용하는 것에 추가 동의합니다.<br>
                당사가 제공하고 있는 공장 내에서 패용하여야 하는 “Smart Tag”는 주기적으로 위치정보를 송신하는 장치이며, 당사는 “Smart Tag”를 통하여 공장 내에서 귀하의 개인 위치 정보를 수집합니다.<br>
                <div class="lineHeight3 mt-4 text-body-2 text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                  <strong class="red--text">[필수]</strong><br>
                </div>
                <div class="lineHeight3 text-subtitle-1 grey--text text--darken-3 mb-2">
                  <table class="type09 text-center text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                    <thead>
                    <tr>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                      <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 항목</td>
                        <td>수집 방법</td>
                        <td>수집·이용목적</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>위치정보</td>
                        <td>Smart Tag (블루투스)</td>
                        <td>안전</td>
                        <td>수집일로부터 1년</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="lineHeight3 mt-4 text-body-2 text-sm-h6 font-weight-bold grey--text text--darken-3">
                    <strong class="red--text">[선택]</strong><br>
                  </div>
                  <table class="type09 text-center text-caption text-sm-subtitle-1 font-weight-bold grey--text text--darken-3">
                    <thead>
                      <tr>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>수집 항목</td>
                        <td>수집 방법</td>
                        <td>수집·이용목적</td>
                        <td>보유 및 이용 기간</td>
                      </tr>
                      <tr>
                        <td>위치정보</td>
                        <td>Smart Tag (블루투스)</td>
                        <td>방문객의 출입 위규 분석</td>
                        <td>수집일로부터 1년, 다만 정보 주체의 출입 보안 관련 위규 사항이 적발되었을 때는 그로부터 사건 처리 종료 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <!-- id="check_order_3" -->
                <v-checkbox v-model="checkbox3" @change="bCheckPart()" color="black" id="check_order_3" dense>
                  <template v-slot:label>
                    <div class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 text-md-h6 grey--text text--darken-3">
                      동의하겠습니다.
                    </div>
                  </template>
                </v-checkbox>    
              </div>
            </div>
            <v-card-text class="text_first_font text--darken-3 lineHeight3">
              본인은 상기 사항을 숙지하였으며, 성실히 준수할 것을 서약합니다. 만일 상기 사항을 위반할 경우 회사의 사규에 따른 어떠한 조치도 감수할 것이며, 관련법률에 따른 민·형사상 책임 및 회사에 발생한 모든 손해에 대한 배상 책임을 부담하겠습니다.
            </v-card-text>

            <v-card-text class="greeting_date text-center">
              {{sNowYear}} 년 {{sNowMounth}} 월 {{sNowDate}} 일
            </v-card-text>
            <v-card-text class="greeting_title text-center">
              {{$store.state.CustomInfo.SiteNm}} 주식회사 귀중
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="pb-0">
              <v-spacer></v-spacer>              
              <v-btn width="100" @click="NextPage()" dark id="bAllCheck2Ref">동의하기</v-btn>
            </v-card-actions>        
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bAuthNotiDialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="headline blue--text font-weight-bold">본인인증방식을 선택하여 주세요.</v-card-title>
        <v-divider></v-divider>
        <!-- <v-card-text class="mt-5">확인 버튼을 누르시면 본인인증 팝업창이 열립니다.<br>본인인증을 진행하여 주세요.</v-card-text> -->
        <v-card-text class="mt-5">
          <div class="d-flex center_all justify-space-around flex-wrap" style="">
            <div cols="12" sm="3" md="3" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="GoAuthModule('phone')">
                <v-icon style="font-size:100px;" class="mb-2">mdi-cellphone</v-icon>
                휴대전화
              </div>
            </div>
            <div cols="12" sm="3" md="3" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="GoAuthModule('card')">
                <v-icon style="font-size:100px;" class="mb-2">mdi-credit-card-outline</v-icon>
                카드
              </div>
            </div>
            <div cols="12" sm="3" md="3" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="GoAuthModule('ipin')">
                <v-icon style="font-size:100px;" class="mb-2">mdi-shield-account</v-icon>
                아이핀
              </div>
            </div>
            <!-- <div v-if="$store.state.CustomInfo.SiteId == 'SKMJ'" cols="12" sm="3" md="3" align="center">             -->
            <!-- <div v-if="$store.state.CustomInfo.SiteId == 'SKMG14' || bTestMode" cols="12" sm="3" md="3" align="center"> -->
            <div v-if="$store.state.CustomInfo.SiteId != 'SKST'" cols="12" sm="3" md="3" align="center">
              <div class="AuthBtn d-flex align-center justify-center flex-column" @click="GoAuthModule('email')">
                <v-icon style="font-size:100px;" class="mb-2">mdi-email-outline</v-icon>
                이메일
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue" text @click="bAuthNotiDialog = false;" class="font-weight-bold"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="isAuthMail" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline font-weight-bold">이메일을 입력하세요</v-card-title>
        <v-card-text class="mt-5">
          <div class="d-flex">
            <v-text-field v-model="cAuthEmail" dense persistent-placeholder label="메일주소" placeholder="test@test.com" ></v-text-field>
            <v-btn class="ml-2 mt-n1" :disabled="isSendMail" @click="onSendAuthMail"><v-icon class="mr-2">mdi-send</v-icon>인증요청</v-btn>
          </div>

          <div class="d-flex">
            <v-text-field v-model="cAuthEmailCode" dense persistent-placeholder label="인증번호" placeholder="인증번호를 입력하세요.">          
            </v-text-field>
            <v-btn class="ml-2 mt-n1" :disabled="!isSendMail" @click="onSendAuthMailCode"><v-icon class="mr-2">mdi-arrow-right</v-icon>다음</v-btn>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="isAuthMail = false; isSendMail = false;" class="font-weight-bold"><v-icon class="mr-2">mdi-close</v-icon>취소</v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EventBus from '@/eventBus.js';
import { mapState } from "vuex";
import BasicInfo from '../BasicInfo';
import Util from "../Util.js";
import axios from "axios"

export default {
  components: {
  },
  data: () => ({
    bTestMode : false,
    cAuthEmail : "",
    cAuthEmailCode : "",
    isAuthMail : false,
    isSendMail : false,
    dialog : false,
    checkbox1 : false,
    checkbox2 : false,
    checkbox3 : false,
    bAuthNotiDialog : false,
    CheckAll : false,
    oSecPeldge : [
      {cId : "1.",cComment : "회사에 출입하면서 알게 된 회사의 정보를 출입 기간(또는 프로젝트 기간)뿐 아니라 출입이 종료된 이후에도  타인에게 누설하지 않겠으며, 출입 기간 중 제공 받은 정보 또는 자료는 출입이 종료될 경우 모두 반납하겠습니다. " },
      {cId : "2.",cComment : "회사의 허가 없이 회사의 물품 또는 자료를 임의로 회사 밖으로 반출하지 않겠습니다." },
      {cId : "3.",cComment : "업무와 무관한 정보를 수집하거나 이와 유사한 행위를 하지 않겠습니다." },
      {cId : "4.",cComment : "정당하지 않은 방법으로 취득한 제 3자의 영업비밀을 회사 구성원에게 제공하지 않겠습니다." },
      {cId : "5.",cComment : "정당하게 취득한 제 3자의 영업비밀이라 하더라도 회사에 제공할 경우 회사가 정한 적법한 방법과 절차를 준수하겠습니다." },
      {cId : "6.",cComment : "출입을 허가받은 건물 또는 장소 이외에는 출입하지 않겠습니다." },
      {cId : "7.",cComment : "업무와 관련하여 회사의 전산시스템 사용을 허가받은 경우 그 권한을 타인과 공유하지 않겠습니다. (전산시스템 아이디 및 패스워드 공유 금지)" },
      {cId : "8.",cComment : "업무와 관련하여 전산시스템을 사용할 경우 회사의 보안정책을 준수하고, 필요시 통신망 이용에 따라 전송되는 정보의 모니터링 및 통제를 할 수 있음에 동의합니다." },
      {cId : "9.",cComment : "회사의 보안정책을 준수할 뿐만 아니라, 이에 대한 위반사례를 발견하였을 경우에는 지체 없이 보안 담당 부서에 신고하겠습니다." },
      {cId : "10.",cComment : "회사 출입과 관련하여 허위 정보 기재 또는 제공, 허위 서류 제출 등 기만행위를 하지 않겠습니다." },
      {cId : "11.",cComment : "업무와 무관한 물품 또는 반입을 금지하는 물품을 회사 내부로 반입하지 않겠습니다." },
      {cId : "12.",cComment : "회사가 발급한 출입증을 육안으로 식별이 가능하도록 노출하여 사업장 내에서는 항상 패용하겠으며 출입증을 타인에게 대여하거나 위·변조하지 않겠으며 기간이 만료된 경우 즉시 반납하겠습니다." },
      {cId : "13.",cComment : "출입을 허가받은 기간 중이라도 프로젝트 종료 등으로 출입 사유가 종료된 경우 출입증을 즉시 반납하겠으며, 출입증을 분실한 경우 24시간 이내에, 회사에 신고하겠습니다. 만약 출입증 미반납 또는 분실 미신고에 따른 회사의 피해 발생 시 일체의 피해를 보상하겠습니다." },
      {cId : "14.",cComment : "회사 내에서 회사의 허가 없이 임의로 사진 촬영을 하지 않겠습니다." },
      {cId : "15.",cComment : "회사의 건물 내에서 허가 없이 경영상 또는 기술상의 정보를 녹음하거나 이와 유사한 행위를 하지 않겠습니다." },
      {cId : "16.",cComment : "회사 내에서 회사의 허가 없이 유인물(판촉물) 배포, 상행위, 모금행위, 선동행위 등을 하지 않겠습니다." },
      {cId : "17.",cComment : "회사 보안주관부서의 정당한 보안 업무 수행에 적극 협조하겠습니다." },
      {cId : "18.",cComment : "회사 보안요원의 정당한 출입 통제 및 보안 검색 업무에 적극 협조하겠습니다." },
      {cId : "19.",cComment : "회사 시설물을 보호하겠으며 시설물을 파손 또는 손괴하였을 경우 손해배상 하겠습니다." },
    ],
  }),

  beforeDestroy(){
    if (this.OpenWindow != null) {
      this.OpenWindow.close();
    }
    window.removeEventListener("message", this.onSendMessage);
  },

  mounted () {
    this.bTestMode = BasicInfo.TEST_MODE;
    window.addEventListener("message", this.onSendMessage);
 },

  computed: {
    ...mapState(["sNowYear","sNowMounth","sNowDate","HomepageURL"]),
  },

  

  methods: {
    Open(){
      this.dialog = true;
      this.bAuthNotiDialog = false;
      
      var ScrollId = ""

      if (window.innerWidth < 960) {
        ScrollId = "TopScrollId_1"
      } else {
        ScrollId = "TopScrollId"
      }

      setTimeout(() => {
        var element = document.getElementById(ScrollId);
        element.scrollIntoView({behavior : "smooth"})
      }, 10);

      this.CheckAll = false;
      this.bCheckAll();
    },

    bCheckAll(RefNm){
      this.checkbox1 = this.CheckAll
      this.checkbox2 = this.CheckAll
      this.checkbox3 = this.CheckAll
      if (this.CheckAll) {
        var element =  document.getElementById(RefNm);
        element.scrollIntoView({behavior : "smooth"})
      }
    },

    bCheckPart(){
      if (this.checkbox1 && this.checkbox2 && this.checkbox3) {
        this.CheckAll = true
      } else {
        this.CheckAll = false
      }
    },

    closePage() {
      this.dialog = false; 
      this.bAuthNotiDialog = false; 
      this.$emit('FailAuth');
    },

    NextPage(){
      if (this.checkbox1 == false) {
        EventBus.$emit("onShowMsgBox", "누락된 사항이 있습니다.", "보안 서약서 동의에 동의해주길 바랍니다.");
        return
      }
      if (this.checkbox2 == false) {
        EventBus.$emit("onShowMsgBox", "누락된 사항이 있습니다.", "개인정보 수집 및 이용 동의에 동의해주길 바랍니다.");
        return
      }
      if (this.checkbox3 == false) {
        EventBus.$emit("onShowMsgBox", "누락된 사항이 있습니다.", "위치정보 수집·이용 동의에 동의해주길 바랍니다.");
        return
      }

      
      this.bAuthNotiDialog = true;
    },

    GoAuthModule(AuthCase) {
      console.log("process.env.VUE_APP_URL_KCB_API", process.env.VUE_APP_URL_KCB_API)
      if (AuthCase == "email") {
        this.cAuthEmail = "";
        this.cAuthEmailCode = "";
        this.isAuthMail = true;
        this.isSendMail = false;
      } else {
        if (this.OpenWindow != null) {
          this.OpenWindow.close()
        }  
        // if(process.env.VUE_APP_URL_KCB_API == "https://skst3.m-4.co.kr/OKName/"){
        //   this.OpenWindow = window.open("https://welcome.sk-materials.com/OKName/" + AuthCase + "_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");
        // }
        // if(process.env.VUE_APP_URL_KCB_API == "https://127.0.0.1/OKName/"){
        //   this.OpenWindow = window.open("https://welcome.sk-materials.com/OKName/" + AuthCase + "_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");
        // }

        // this.OpenWindow = window.open("https://welcome.sk-materials.com/OKName/" + AuthCase + "_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");
        this.OpenWindow = window.open(process.env.VUE_APP_URL_KCB_API + AuthCase + "_popup2.asp", "auth_popup", "width=430, height=600, scrollbars=yes, location=no");

      }
    },

    // GoAuthModule(AuthCase) {
    //   if (AuthCase === "email") {
    //     this.cAuthEmail = "";
    //     this.cAuthEmailCode = "";
    //     this.isAuthMail = true;
    //     this.isSendMail = false;
    //     return;
    //   }

    //   // 기존 팝업 닫기
    //   if (this.OpenWindow && !this.OpenWindow.closed) {
    //     this.OpenWindow.close();
    //   }



    //   this.OpenWindow = window.open(
    //     authUrl,
    //     "auth_popup",
    //     "width=430,height=600,scrollbars=yes,location=no"
    //   );
    // },


    onSendMessage(event) {
      console.log(event);
      this.bAuthNotiDialog = false;
      if (event.data.RSLT_CD == "B000") {
        this.$emit('ClosePledge',event.data)
      } else if (event.data.key=="__VUE_DEVTOOLS_VUE_DETECTED_EVENT__") {
        console.log("__VUE_DEVTOOLS_VUE_DETECTED_EVENT__");
      } else {
        this.dialog = false;
        this.$emit('FailAuth')
        EventBus.$emit("onShowMsgBox", "본인 인증에 실패하였습니다.", "관리자에게 문의 바랍니다.");
      }
    },

    onSendAuthMail() {
      let oCheckEmail = Util.CheckEmail(this.cAuthEmail)
      if (!oCheckEmail.bResult) {
        EventBus.$emit("onShowMsgBox", "이메일 주소가 정확하지 않습니다.","입력하신 이메일을 확인하여 주세요.");
        return;
      }

      this.cAuthEmail = oCheckEmail.cEmail;

      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        cEmail : this.cAuthEmail,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "AuthEmail", posData, {headers: {}})
        .then(res => {
          if (res.data.ResultCd === "00") {  
            this.isSendMail = true;
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        // .catch(err => {
        //   EventBus.$emit("onShowMsg",true, ""+err);        
        // });
    },
    onSendAuthMailCode() {      
      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        Email : this.cAuthEmail,
        Code : this.cAuthEmailCode,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "CheckAuthNumEmail", posData, {
          headers: {}
        })
        .then(res => {
          if (res.data.ResultCd == "00") {
            this.isAuthMail = false;
            this.isSendMail = false;
            this.bAuthNotiDialog = false;
            this.$emit('ClosePledge',{RSLT_CD:'email', Code : this.cAuthEmailCode});

            EventBus.$emit("onShowMsg",false, "인증이 완료 되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","인증번호가 일치하지 않습니다.","입력하신 인증번호를 확인 하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

  }
};
</script>

<style lang="scss" scoped>
  @import "../publishing/visit.scss";
  .AuthBtn {
    color : black;
    cursor : pointer;
    width : 120px;
    height : 150px;
  }

  .AuthBtn:hover {
    opacity: 1;
    /* font-weight: 900 !important; */
    background: #FFFFFF22;
    border-radius: 20px;
    box-shadow: 0px 0px 20px #00000022;
  }

  .Medium_Font {
    font-family: "Noto Sans Korean", "Malgun Gothic", "돋움", "dotum", "AppleGothic", Helvetica, Arial, sans-serif;
    font-weight: 400;
    color: #666
  }
  .lineHeight2{
    line-height: 180%
  }
  .lineHeight3{
    line-height: 150%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }

  table.type09 {
    border-collapse: collapse;
    text-align: left;
    line-height: 1.5;
    width : 100%;
  }
  table.type09 thead th {
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    /* color: #369; */
    border-bottom: 2px solid rgb(141, 141, 141);
  }
  table.type09 tbody th {
    width: 150px;
    padding: 10px;
    font-weight: bold;
    vertical-align: top;
    border-bottom: 1px solid #ccc;
    background: #f3f6f7;
  }
  table.type09 td {
    width: 350px;
    padding: 10px;
    vertical-align:center;
    border-bottom: 1px solid #ccc;
  }

  .pledge_title {
    word-break: keep-all;

    @media screen and (min-width: 1065px) {
      font-size: 2.125rem;
      font-weight: 400;
      height : 90px;

      :deep(img) {
        height : 45px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      font-size: 1.5rem;
      font-weight: 500;
      height : 70px;

      :deep(img) {
        height : 35px;
      }
    }

    @media screen and (max-width: 601px) {
      padding : 0px;
      font-size: 0.9rem;
      font-weight: 500;
      height : 50px;

      :deep(img) {
        height : 20px;
      }
    }
  }
  
  .pledge_content {
    overflow:auto;
    @media screen and (min-width: 1065px) {
      height:calc(90vh - 155px);

      :deep(.v-card__text) {
        letter-spacing: .0125rem;
        font-size: 1.25rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .009375rem;
        font-size: 1rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (min-width: 600px) and (max-width: 1064px){
      height:calc(90vh - 135px);

      :deep(.v-card__text) {
        // background-color : blue;
        letter-spacing: .01rem;
        font-size: 1rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        // background-color : green;
        letter-spacing: .009375rem;
        font-size: 0.9rem;
        font-weight: 400;
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    @media screen and (max-width: 601px) {
      height:calc(90vh - 115px);
      :deep(.v-card__text) {
        letter-spacing: .0075rem;
        font-size: 0.9rem;
        font-weight: 500;
      }

      :deep(.content_subtitle) {
        letter-spacing: .007rem;
        font-size: 0.8rem;
        font-weight: 400;
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }
</style>
